<template>
  <div class="containter">
    <el-row>
      <!-- 安全 -->
      <el-col :span="8">
        <div class="panel safe">
          <span class="icon iconfont">&#xe895;</span>
          <span class="smallTile cursor"  @click="jumpModelPage('SAFE')">安全</span>
          <!-- 散点图 -->
          <el-row>
            <el-col :span="14">
              <div class="safeScatter">
                <!-- <lx-scatter :optionData="fullScatter3D"></lx-scatter> -->
                <img v-show="isShowSafeScaleImg" src="@/assets/imgs/scaleBg.png" alt="">
                <img
                  class="bigWormbox"
                  v-show="safeIsShowImg"
                  :src="require(`@/assets/imgs/${safeImgUrl}.png`)"
                  alt=""
                  :style="{
                    'border-color': statusColor(resultData.safeModelStatus),
                  }"
                />
                <div class="scater">
                  <lx-scatter2D :optionData="safeScatter2D" :color="safeScatterHisColor"></lx-scatter2D>
                </div>
                <div :style="{'color':safeBoundary1?'#ff0000':'#ffffff'}" class="securityBoundary1" v-show="safeIsShowImg">安全边界</div>
                <div :style="{'color':safeBoundary2?'#ff0000':'#ffffff'}" class="securityBoundary2" v-show="safeIsShowImg">安全边界</div>
                <div :style="{'color':safeBoundary3?'#ff0000':'#ffffff'}" class="securityBoundary3" v-show="safeIsShowImg">安全边界</div>
                <div :style="{'color':safeBoundary4?'#ff0000':'#ffffff'}" class="securityBoundary4" v-show="safeIsShowImg">安全边界</div>
                <div class="desc1">模式化应用可视界面</div>
                <div class="desc2">Wormbox®️蚯蚓盒®️</div>
              </div>
            </el-col>
            <el-col :span="10">
              <br>
              <div class="status">运行状态: {{ status(resultData.safeModelStatus) }}</div>
              <!-- 模式化状态点 -->
              <div class="wormboxMini">
                <div>状态点位置：</div>
                <div>{{ `（${resultData.safeScatterData.mainData.d1}, ${resultData.safeScatterData.mainData.d2}, ${resultData.safeScatterData.mainData.d3}）` }}</div>
                <br>
                <div>当前视图：{{ safeCurrView }}</div>
                <el-row>
                  <el-col :span="8">
                    <div class="miniScatter" @click="safeFrontView()">
                      <img
                        class="wormbox"
                        src="@/assets/imgs/wormbox.png"
                        alt=""
                        :class="{miniWormBoxBorder: safeCurrView=='主视图'}"
                      />
                      <div class="miniScatter1">
                        <lx-scatter2D :optionData="safeMiniScatter1" :color="safeScatterHisColor"></lx-scatter2D>
                      </div>
                      <div class="leftTop1" v-if="resultData.safeScatterData.direction == 2"></div>
                      <div class="rightTop1" v-if="resultData.safeScatterData.direction == 1"></div>
                      <div class="leftBottom1" v-if="resultData.safeScatterData.direction == 3"></div>
                      <div class="rightBottom1" v-if="resultData.safeScatterData.direction == 4"></div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="miniScatter" @click="safeSideView()">
                      <img
                        class="wormbox"
                        src="@/assets/imgs/wormbox.png"
                        alt=""
                        :class="{miniWormBoxBorder: safeCurrView=='侧视图'}"
                      />
                      <div class="miniScatter1">
                        <lx-scatter2D :optionData="safeMiniScatter2" :color="safeScatterHisColor"></lx-scatter2D>
                      </div>
                      <div class="leftTop2" v-if="resultData.safeScatterData.direction == 10"></div>
                      <div class="rightTop2" v-if="resultData.safeScatterData.direction == 9"></div>
                      <div class="leftBottom2" v-if="resultData.safeScatterData.direction == 11"></div>
                      <div class="rightBottom2" v-if="resultData.safeScatterData.direction == 12"></div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="miniScatter" @click="safeVerticalView()">
                      <img
                        class="wormbox"
                        src="@/assets/imgs/wormbox.png"
                        alt=""
                        :class="{miniWormBoxBorder: safeCurrView=='俯视图'}"
                      />
                      <div class="miniScatter1">
                        <lx-scatter2D :optionData="safeMiniScatter3" :color="safeScatterHisColor"></lx-scatter2D>
                      </div>
                      <div class="leftTop3" v-if="resultData.safeScatterData.direction == 6"></div>
                      <div class="rightTop3" v-if="resultData.safeScatterData.direction == 5"></div>
                      <div class="leftBottom3" v-if="resultData.safeScatterData.direction == 7"></div>
                      <div class="rightBottom3" v-if="resultData.safeScatterData.direction == 8"></div>
                    </div>
                  </el-col>
                </el-row>
                <div class="miniView">
                  <el-button
                    type="text"
                    style="color: white"
                    class="safeFrontView"
                    @click="safeFrontView()"
                    >主视图</el-button
                  >
                  <el-button
                    type="text"
                    style="color: white"
                    class="safeSideView"
                    @click="safeSideView()"
                    >侧视图</el-button
                  >
                  <el-button
                    type="text"
                    style="color: white"
                    class="safeVerticalView"
                    @click="safeVerticalView()"
                    >俯视图</el-button
                  >
                </div>
                <br>
                <br>
                <br>
                <el-button
                  class="isScaleBtn"
                  size="mini"
                  type="primary"
                  @click="safeIsScaleBtn()"
                >
                  {{ safeIsScale }}
                </el-button>
              </div>
            </el-col>
          </el-row>
          <br />
          <br>
          <!-- 趋势图-->
          <el-row>
            <el-col :span="24">
              <div class="safeLine">
                <lx-linechart :optionData="safe_linechart"></lx-linechart>
              </div>
            </el-col>
          </el-row>
          <br>
          <!-- 列表 -->
          <el-row>
            <el-col :span="24">
              <div>
                <div class="center">模式工况列表</div>
                <div class="list">
                  <el-table
                    :data="resultData.conList"
                    height="150px"
                    style="width: 100%; background: transparent; font-size: 6px"
                    :header-cell-style="{
                      color: 'white',
                      textAlign: 'center',
                      fontSize: '14px',
                    }"
                    :cell-style="{ color: 'white', textAlign: 'center' }"
                  >
                    <el-table-column
                      prop="tagNo"
                      label="位号"
                      show-overflow-tooltip
                      width="80"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="processValue"
                      label="当前值"
                      show-overflow-tooltip
                      width="80"
                    >
                    <template slot-scope="scope">
                      <div :style="{'background': listColor[scope.row.isOverLimit]}">{{ scope.row.processValue }}</div>
                    </template>
                    </el-table-column>
                    <el-table-column
                      prop="highLimit"
                      label="高限"
                      show-overflow-tooltip
                      width="80"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="lowerLimit"
                      label="低限"
                      show-overflow-tooltip
                      width="80"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="weight"
                      label="占比"
                      show-overflow-tooltip
                      width="60"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="tagNoAndDesc"
                      label="描述"
                      show-overflow-tooltip
                      width="180"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 仪表 -->
          <el-row>
            <el-col :span="8">
              <div class="safe_gauge">
                <lx-gauge :gaugeData="safe_gkGauge"></lx-gauge>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="safe_gauge">
                <lx-gauge :gaugeData="safe_yjGauge"></lx-gauge>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="safe_gauge">
                <lx-gauge :gaugeData="safe_wdGauge"></lx-gauge>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <!-- 运行模态 -->
      <el-col :span="16">
        <div class="panel device">
          <router-view></router-view>
        </div>
        <el-row>
          <!-- 全流程 -->
          <el-col :span="17">
            <div class="panel full">
              <div class="fullTitle">
                <span class="icon iconfont">&#xe612;</span>
                <span class="smallTile cursor" @click="jumpModelPage('FULL')">全流程</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <div class="fullLine">
                    <lx-linechart :optionData="full_linechart"></lx-linechart>
                  </div>
                  <el-row>
                    <el-col :span="8">
                      <div class="full_Gauge">
                        <lx-gauge :gaugeData="full_gkGauge"></lx-gauge>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="full_Gauge">
                        <lx-gauge :gaugeData="full_wdGauge"></lx-gauge>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="full_Gauge">
                        <lx-gauge :gaugeData="full_yjGauge"></lx-gauge>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="12">
                  <div class="fullScatter">
                    <img v-show="isShowFullScaleImg" src="@/assets/imgs/scaleBg.png" alt="">
                    <img
                      class="bigWormbox"
                      v-show="isShowImg"
                      :src="require(`@/assets/imgs/${fullImgUrl}.png`)"
                      alt=""
                      :style="{
                        'border-color': statusColor(resultData.fullModelStatus)
                      }"
                    />
                    <div class="scater">
                      <lx-scatter2D :optionData="fullScatter2D" :color="fullScatterHisColor"></lx-scatter2D>
                    </div>
                    <div class="status">运行状态:{{ status(resultData.fullModelStatus) }}</div>
                    <!-- <div class="currStatus"></div> -->
                    <div class="gradient"></div>
                    <div class="mark1">{{ resultData.fullScatterData.optDesc[0] }}</div>
                    <div class="mark2">{{ resultData.fullScatterData.optDesc[1] }}</div>
                    <div :style="{'color':fullBoundary1?'#ff0000':'#ffffff'}" class="securityBoundary1" v-show="isShowImg">安全边界</div>
                    <div :style="{'color':fullBoundary2?'#ff0000':'#ffffff'}" class="securityBoundary2" v-show="isShowImg">安全边界</div>
                    <div :style="{'color':fullBoundary3?'#ff0000':'#ffffff'}" class="securityBoundary3" v-show="isShowImg">安全边界</div>
                    <div :style="{'color':fullBoundary4?'#ff0000':'#ffffff'}" class="securityBoundary4" v-show="isShowImg">安全边界</div>
                    <div class="desc1">模式化应用可视界面</div>
                    <div class="desc2">Wormbox®️蚯蚓盒®️</div>
                  </div>
                  <el-button
                    class="isScaleBtn"
                    size="mini"
                    type="primary"
                    @click="isScaleBtn()"
                    >{{ isScale }}</el-button
                  >
                  <!-- 模式化状态点 -->
                  <div class="wormboxMini">
                    <div>{{ `状态点位置：（${resultData.fullScatterData.mainData.d1}, ${resultData.fullScatterData.mainData.d2}, ${resultData.fullScatterData.mainData.d3}）` }}</div>
                    <el-row>
                      <el-col :span="6">
                        <div class="center currentView">当前视图</div>
                        <div class="center">{{ fullCurrView }}</div>
                      </el-col>
                      <el-col :span="6">
                        <div class="miniScatter" @click="frontView()">
                          <img
                            class="wormbox"
                            src="@/assets/imgs/wormbox.png"
                            alt=""
                            :class="{miniWormBoxBorder: fullCurrView=='主视图'}"
                          />
                          <div class="miniScatter1">
                            <lx-scatter2D
                              :optionData="fullMiniScatter1"
                              :color="fullScatterHisColor"
                            ></lx-scatter2D>
                          </div>
                          <div class="leftTop1" v-if="resultData.fullScatterData.direction == 2"></div>
                          <div class="rightTop1" v-if="resultData.fullScatterData.direction == 1"></div>
                          <div class="leftBottom1" v-if="resultData.fullScatterData.direction == 3"></div>
                          <div class="rightBottom1" v-if="resultData.fullScatterData.direction == 4"></div>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="miniScatter" @click="sideView()">
                          <img
                            class="wormbox"
                            src="@/assets/imgs/wormbox.png"
                            alt=""
                            :class="{miniWormBoxBorder: fullCurrView=='侧视图'}"
                          />
                          <div class="miniScatter1">
                            <lx-scatter2D
                              :optionData="fullMiniScatter2"
                              :color="fullScatterHisColor"
                            ></lx-scatter2D>
                          </div>
                          <div class="leftTop2" v-if="resultData.fullScatterData.direction == 10"></div>
                          <div class="rightTop2" v-if="resultData.fullScatterData.direction == 9"></div>
                          <div class="leftBottom2" v-if="resultData.fullScatterData.direction == 11"></div>
                          <div class="rightBottom2" v-if="resultData.fullScatterData.direction == 12"></div>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="miniScatter" @click="verticalView()">
                          <img
                            class="wormbox"
                            src="@/assets/imgs/wormbox.png"
                            alt=""
                            :class="{miniWormBoxBorder: fullCurrView=='俯视图'}"
                          />
                          <div class="miniScatter1">
                            <lx-scatter2D
                              :optionData="fullMiniScatter3"
                              :color="fullScatterHisColor"
                            ></lx-scatter2D>
                          </div>
                          <div class="leftTop3" v-if="resultData.fullScatterData.direction == 6"></div>
                          <div class="rightTop3" v-if="resultData.fullScatterData.direction == 5"></div>
                          <div class="leftBottom3" v-if="resultData.fullScatterData.direction == 7"></div>
                          <div class="rightBottom3" v-if="resultData.fullScatterData.direction == 8"></div>
                        </div>
                      </el-col>
                    </el-row>
                    <div class="miniView">
                      <el-button type="text" style="color: white" @click="frontView()"
                        >主视图</el-button
                      >
                      <el-button type="text" style="color: white" @click="sideView()"
                        >侧视图</el-button
                      >
                      <el-button type="text" style="color: white" @click="verticalView()"
                        >俯视图</el-button
                      >
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <!-- 运行评估 -->
          <el-col :span="7">
            <div class="panel group">
              <span class="icon iconfont">&#xe65a;</span>
              <span class="smallTile">运行评估</span>
              <el-row>
                <el-col :span="21">
                  <el-row>
                    <div class="teamScore">
                      <lx-bar :barData="bar"></lx-bar>
                    </div>
                    <div class="linechart">
                      <lx-linechart
                        :optionData="groups_linechart"
                      ></lx-linechart>
                    </div>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12" :offset="8"> </el-col>
                  </el-row>
                </el-col>
                <el-col :span="3">
                  <div class="info">
                    <div>当前班组：{{ resultData.groupEvaluation.curGroup }}</div>
                    <br />
                    <div>上一个班组：{{ resultData.groupEvaluation.lastGroup }}</div>
                    <br />
                    <div>交接班时间：{{ resultData.groupEvaluation.shiftDateDesc }}</div>
                    <br />
                    <div>{{ this.bar.names[0] }}班总报警次数：{{ resultData.groupEvaluation.groupWarnNum[0] }}</div>
                    <div>{{ this.bar.names[1] }}班总报警次数：{{ resultData.groupEvaluation.groupWarnNum[1] }}</div>
                    <div>{{ this.bar.names[2] }}班总报警次数：{{ resultData.groupEvaluation.groupWarnNum[2] }}</div>
                    <div>{{ this.bar.names[3] }}班总报警次数：{{ resultData.groupEvaluation.groupWarnNum[3] }}</div>
                    <br />
                    <br />
                    <el-button type="primary" @click="goReport()" size="mini"
                      >报表系统</el-button
                    >
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Message } from "element-ui";
import { homePage , getPublicConfig} from "@/api/wormBox"
import { mapState ,mapMutations} from "vuex"
import { jumpModelBtn} from "@/utils/control"
export default {
  data() {
    return {
      listColor:["rgba(255,255,255,0)","red","rgba(255,255,255,0)","grey","rgba(255,255,255,0)"],//0未超，1超限，3坏点，4停滞数据
      safeScatterHisColor:["#0D0DF5","#3B6FF2","#4671CB","#B2ADAD"],
      fullScatterHisColor:["#0D0DF5","#3B6FF2","#4671CB","#B2ADAD"],
      fullScatter3D: {
        boxWidth: 150,
        boxHeight: 150,
        boxDepth: 150,
        width: "100%",
        height: "100%",
        ballColor: [
          "rgba(2,240,15,0.3)",
          "rgba(240,240,15,0.3)",
          "rgba(240,75,15,0.3)",
          "rgba(157,149,147,0.3)",
        ],
        scatter3DData: [
          [-7, 2, 8, 1650722239000],
          [-2.5, 2.5, 8, 1650722239000],
          [3, 3, 8, 1650722239000],
          [4, 3.5, 8, 1650722239000],
        ],
        color: [
          "rgba(234,57,10,0.3)",
          "rgba(41,234,10,0.3)",
          "rgba(13,209,229,0.3)",
          "rgba(59,77,185,0.3)",
          "rgba(3,12,249,0.3)",
          "rgba(178,173,173,0.3)",
        ],
        scatterSize: 20,
        x_l: -10,
        x_h: 10,
        y_l: -10,
        y_h: 10,
        z_l: -10,
        z_h: 10,
      },
      safeScatter3D: {
        boxWidth: 150,
        boxHeight: 150,
        boxDepth: 150,
        width: "100%",
        height: "100%",
        ballColor: [
          "rgba(2,240,15,0.3)",
          "rgba(240,240,15,0.3)",
          "rgba(240,75,15,0.3)",
          "rgba(157,149,147,0.3)",
        ],
        scatter3DData: [
          [0, 0, 0, 1650722239000],
          [-2.5, 3, 8, 1650722239000],
          [1, 3, 8, 1650722239000],
          [4, 3.5, 8, 1650722239000],
        ],
        color: [
          "rgba(234,57,10,0.3)",
          "rgba(41,234,10,0.3)",
          "rgba(13,209,229,0.3)",
          "rgba(59,77,185,0.3)",
          "rgba(3,12,249,0.3)",
          "rgba(178,173,173,0.3)",
        ],
        scatterSize: 20,
        x_l: -10,
        x_h: 10,
        y_l: -10,
        y_h: 10,
        z_l: -10,
        z_h: 10,
      },
      safeScatter2D: {
        symbolSize:15,
        isZoom: false,
        xl: -500,
        xh: 500,
        yl: -500,
        yh: 500,
        XName:"X",
        YName:"Y",
        data: [
          [0, 0, 1650722239000],
        ]
      },
      fullScatter2D: {
        xl: -500,
        xh: 500,
        yl: -500,
        yh: 500,
        isZoom: false,
        symbolSize:15,
        XName:"X",
        YName:"Y",
        data: [
          [0, 0, 1650722239000]
        ],
      },
      safeImgUrl: "safe",
      fullImgUrl: "PVC_FULL",
      isShowImg: true,
      baseStatusColor: ["green", "#EBE00D", "red", "grey"], //通过配置界面可修改
      isScale: "开启缩放",
      isShowFullScaleImg:false,
      safeIsScale: "开启缩放",
      safeIsShowImg: true,
      isShowSafeScaleImg:false,
      safeCurrView:"主视图",
      fullCurrView:"主视图",
      full_linechart: {
        name: ["模式工况指数", "稳定指数", "预警时间"],
        yAxisIndex: [0, 0, 1],
        xtime: [1650722239000, 1689226848000, 1689226548000, 1689226748000],
        data: ["89", "95", "96", "98"],
        data1: ["96", "89", "97", "99"],
        data2: ["11", "10", "11", "12"],
        y: true,
        left: "3%",
        right: "8%",
        min: -2,
        max: 14,
        interval: 2,
        orient: "horizontal",
        legendY: "top",
        legendX: "right",
        xInterval: 30,
        spacing: "15%",
        y0Min: -10,
        y0Max: 110,
        y0Interval: 30,
        interval:4
      },
      full_gkGauge: {
        gaugename: "模式工况指数(%)",
        data: 0,
        max: "100",
        radius: "70%",
        center: ["50%", "45%"],
        pointerColor: "#5470C6",
        titleFontSize: 18,
      },
      full_yjGauge: {
        gaugename: "预警时间(h)",
        data: 0,
        max: "12",
        radius: "70%",
        center: ["50%", "45%"],
        pointerColor: "#5470C6",
        titleFontSize: 18,
      },
      full_wdGauge: {
        gaugename: "稳定指数(%)",
        data: 0,
        max: "100",
        radius: "70%",
        center: ["50%", "45%"],
        pointerColor: "#5470C6",
        titleFontSize: 18,
      },
      bar: {
        text: "",
        title: false,
        values: [0, 0, 0, 0],
        names: ["甲", "乙", "丙", "丁"],
      },
      safe_linechart: {
        name: ["模式工况指数", "稳定指数", "预警时间"],
        yAxisIndex: [0, 0, 1],
        xtime: [1650722239000, 1689226848000, 1689226548000, 1689226748000],
        data: ["50", "30", "98", "95"],
        data1: ["93", "87", "97", "96"],
        data2: ["12", "12", "10", "12"],
        y: true,
        left: "3%",
        right: "8%",
        min: -2,
        max: 14,
        interval: 2,
        orient: "horizontal",
        legendY: "centers",
        legendX: "center",
        xInterval: 30,
        spacing: "15%",
        y0Min: -10,
        y0Max: 110,
        y0Interval: 30,
        interval:4
      },
      safe_gkGauge: {
        gaugename: "模式工况指数(%)",
        data: 0,
        max: "100",
        radius: "70%",
        center: ["50%", "45%"],
        pointerColor: "#5470C6",
        titleFontSize: 20,
      },
      safe_yjGauge: {
        gaugename: "预警时间(h)",
        data: 0,
        max: "12",
        radius: "70%",
        center: ["50%", "45%"],
        pointerColor: "#5470C6",
        titleFontSize: 20,
      },
      safe_wdGauge: {
        gaugename: "稳定指数(%)",
        data: 0,
        max: "100",
        radius: "70%",
        center: ["50%", "45%"],
        pointerColor: "#5470C6",
        titleFontSize: 20,
      },
      groups_linechart: {
        name: ["综合评分"],
        yAxisIndex: [0],
        xtime: [1650722239000, 1689226848000, 1689226548000, 1689226748000],
        data: ["10", "30", "50", "90"],
        y: false,
        left: "-10%",
        right: "35%",
        min: -2,
        max: 14,
        interval: 2,
        orient: "horizontal",
        legendY: "top",
        legendX: "center",
        xInterval: 40,
        spacing: "15%",
        y0Min: -10,
        y0Max: 110,
        y0Interval: 30,
      },
      safeMiniScatter1: {
        symbolSize:10,
        xl: -500,
        xh: 500,
        yl: -500,
        yh: 500,
        isZoom: false,
        XName:"X",
        YName:"Y",
        data: [
          [0, 0, 1689226848000],
        ],
      },
      safeMiniScatter2: {
        xl: -500,
        xh: 500,
        yl: -500,
        yh: 500,
        isZoom: false,
        symbolSize:10,
        XName:"Z",
        YName:"Y",
        data: [
          [0, 0, 1689226848000],
        ],
      },
      safeMiniScatter3: {
        xl: -500,
        xh: 500,
        yl: -500,
        yh: 500,
        isZoom: false,
        symbolSize:10,
        XName:"X",
        YName:"Z",
        data: [
          [0, 0, 1689226848000],
        ],
      },
      fullMiniScatter1: {
        symbolSize:10,
        xl: -500,
        xh: 500,
        yl: -500,
        yh: 500,
        isZoom: false,
        XName:"X",
        YName:"Y",
        data: [
          [0, 0, 1689226848000],
        ],
      },
      fullMiniScatter2: {
        xl: -500,
        xh: 500,
        yl: -500,
        yh: 500,
        isZoom: false,
        symbolSize:10,
        XName:"Z",
        YName:"Y",
        data: [
          [0, 0, 1689226848000],
        ],
      },
      fullMiniScatter3: {
        xl: -500,
        xh: 500,
        yl: -500,
        yh: 500,
        isZoom: false,
        symbolSize:10,
        XName:"X",
        YName:"Z",
        data: [
          [0, 0, 1689226848000],
        ],
      },
      
      // 返回结果
      resultData:{
        safeModelStatus: 0,
        fullModelStatus: 0,
        safeScatterData:{
          currentViewType:"侧视图",
          mainData:{
            d1:32,
            d2:5.7,
            d3:40
          }
        },
        fullScatterData:{
          currentViewType:"侧视图",
          optDesc:["低产率","高产率"],
          mainData:{
            d1:2,
            d2:3,
            d3:4
          }
        },
        conList: [
          {
            weight: "2.1",
            processValue: "55.72",
            tagNoAndDesc:
              "14号电解槽电流"
          },
          {
            weight: "1.8",
            processValue: "72.4",
            tagNoAndDesc: "T208换热器出口温度"
          },
          {
            weight: "1.6",
            processValue: "6.4",
            tagNoAndDesc: "T325塔顶压力"
          },
          {
            weight: "1.2",
            processValue: "89.65",
            tagNoAndDesc: "T325塔顶抽出"
          },
          {
            weight: "10",
            processValue: "88",
            tagNoAndDesc: "测试"
          },
          {
            weight: "10",
            processValue: "88",
            tagNoAndDesc: "测试"
          },
          {
            weight: "10",
            processValue: "88",
            tagNoAndDesc: "测试"
          }
        ],
        groupEvaluation:{
          curGroup:"一班",
          lastGroup:"四班",
          shiftDateDesc:"2023-7-13 21:00:00",
          groupWarnNum:[1,2,2,0]
        }
      },
      timerId: null,
      safeControlScatter:0, //0默认后端返回 1\2\3手动切换
      safeCurPage:null,
      fullControlScatter:0, //0默认后端返回 1\2\3手动切换
      fullCurPage:null,
      safeBoundary1:false,
      safeBoundary2:false,
      safeBoundary3:false,
      safeBoundary4:false,
      fullBoundary1:false,
      fullBoundary2:false,
      fullBoundary3:false,
      fullBoundary4:false,
      message:null,
      safeScaleFlag:0, //0关闭缩放，1开启缩放
      fullScaleFlag:0, //0关闭缩放，1开启缩放
    };
  },
  computed:{
    ...mapState(["hisParams","isHis"]),
  },
  methods: {
    ...mapMutations(["setIsHis","setRunStateInfo"]),
    defaultTime(timeStamp) {
      let tm = new Date(timeStamp);
      let y = tm.getFullYear();
      let mon = tm.getMonth() + 1;
      let d = tm.getDate();
      let hh = (tm.getHours() + "").padStart(2, 0);
      let ii = (tm.getMinutes() + "").padStart(2, 0);
      let ss = (tm.getSeconds() + "").padStart(2, 0);
      return `${y}/${mon}/${d}\n${hh}:${ii}:${ss}`;
    },
    timeX() {
      this.safe_linechart.xtime = this.safe_linechart.xtime.map((item) => {
        return (item = this.defaultTime(item));
      });
      this.full_linechart.xtime = this.full_linechart.xtime.map((item) => {
        return (item = this.defaultTime(item));
      });
      this.groups_linechart.xtime = this.groups_linechart.xtime.map((item) => {
        return (item = this.defaultTime(item));
      });
    },
    goReport() {
      // this.$router.push("report");
      this.$router.push({path:"/report",query:{homePage:this.$route.query.homePage}})
    },
    //状态颜色
    statusColor(colorValue) {
      if (colorValue == 0) {
        return this.baseStatusColor[0];
      } else if (colorValue == 1) {
        return this.baseStatusColor[1];
      } else if (colorValue == 2) {
        return this.baseStatusColor[2];
      } else {
        return this.baseStatusColor[3];
      }
    },
    // 主视图
    frontView() {
      this.fullImgUrl = `${this.$route.query.homePage}_FULL_Z`
      this.fullCurrView = "主视图"
      this.fullControlScatter = 1
      this.fullCurPage = this.$route.query.index
      const {fullScatterData} = this.resultData
      this.fullScatter2D = {...this.fullScatter2D , ...fullScatterData.scatterData}
      this.fullScatter2D.XName = "X"
      this.fullScatter2D.YName = "Y"
    },
    // 侧视图
    sideView() {
      this.fullImgUrl = `${this.$route.query.homePage}_FULL_C`
      this.fullCurrView = "侧视图"
      this.fullControlScatter = 3
      this.fullCurPage = this.$route.query.index
      const {fullScatterData} = this.resultData
      this.fullScatter2D = {...this.fullScatter2D , ...fullScatterData.scatterData1}
      this.fullScatter2D.XName = "Z"
      this.fullScatter2D.YName = "Y"
    },
    // 俯视图
    verticalView() {
      this.fullImgUrl = `${this.$route.query.homePage}_FULL_F`
      this.fullCurrView = "俯视图"
      this.fullControlScatter = 2
      this.fullCurPage = this.$route.query.index
      const {fullScatterData} = this.resultData
      this.fullScatter2D = {...this.fullScatter2D , ...fullScatterData.scatterData2}
      this.fullScatter2D.XName = "X"
      this.fullScatter2D.YName = "Z"
    },
    isScaleBtn() {
      this.fullScatter2D.isZoom == true
        ? (this.fullScatter2D.isZoom = false)
        : (this.fullScatter2D.isZoom = true);
      this.isShowImg == false
        ? (this.isShowImg = true)
        : (this.isShowImg = false);
      this.isShowFullScaleImg ==  false ? this.isShowFullScaleImg = true : this.isShowFullScaleImg = false
      this.isScale == "开启缩放"
        ? (this.isScale = "禁用缩放")
        : (this.isScale = "开启缩放");

      this.fullScaleFlag == 0 ? this.fullScaleFlag = 1 : this.fullScaleFlag = 0
    },
    safeIsScaleBtn() {
      this.safeScatter2D.isZoom == true
        ? (this.safeScatter2D.isZoom = false)
        : (this.safeScatter2D.isZoom = true);
      this.safeIsShowImg == false
        ? (this.safeIsShowImg = true)
        : (this.safeIsShowImg = false);
      this.isShowSafeScaleImg ==  false ? this.isShowSafeScaleImg = true : this.isShowSafeScaleImg = false
      this.safeIsScale == "开启缩放"
        ? (this.safeIsScale = "禁用缩放")
        : (this.safeIsScale = "开启缩放");

      this.safeScaleFlag == 0 ? this.safeScaleFlag = 1 : this.safeScaleFlag = 0;
    },
    // 安全主视图
    safeFrontView() {
      this.safeCurrView = "主视图"
      this.safeControlScatter = 1
      this.safeCurPage = this.$route.query.index
      const {safeScatterData} = this.resultData
      this.safeScatter2D = {...this.safeScatter2D , ...safeScatterData.scatterData}
      this.safeScatter2D.XName = "X"
      this.safeScatter2D.YName = "Y"
    },
    // 安全侧视图
    safeSideView() {
      this.safeCurrView = "侧视图"
      this.safeControlScatter = 3
      this.safeCurPage = this.$route.query.index
      const {safeScatterData} = this.resultData
      this.safeScatter2D = {...this.safeScatter2D , ...safeScatterData.scatterData1}
      this.safeScatter2D.XName = "Z"
      this.safeScatter2D.YName = "Y"
    },
    // 安全俯视图
    safeVerticalView() {
      this.safeCurrView = "俯视图"
      this.safeControlScatter = 2
      this.safeCurPage = this.$route.query.index
      const {safeScatterData} = this.resultData
      this.safeScatter2D = {...this.safeScatter2D , ...safeScatterData.scatterData2}
      this.safeScatter2D.XName = "X"
      this.safeScatter2D.YName = "Z"
    },
    //运行状态
    status(status){
      if (status == 0) {
        return this.currStatus = "正常"
      } else if (status == 1) {
        return this.currStatus = "预警"
      } else if(status == 2){
        return this.currStatus = "报警"
      }else if (status == 3){
        return this.currStatus = "停工"
      }
    },
    //安全当前视图
    safeCurrViewName(currentViewType){
      if (currentViewType == "0"){
        return this.safeCurrView = "主视图"
      }else if (currentViewType == "2"){
        return this.safeCurrView = "侧视图"
      }else if (currentViewType == "1"){
        return this.safeCurrView = "俯视图"
      }else{
        return this.safeCurrView = "类型错误"
      }
    },
    //全流程当前视图
    fullCurrViewName(currentViewType){
      if (currentViewType == "0"){
        return this.fullCurrView = "主视图"
      }else if (currentViewType == "2"){
        return this.fullCurrView = "侧视图"
      }else if (currentViewType == "1"){
        return this.fullCurrView = "俯视图"
      }else{
        return this.fullCurrView = "类型错误"
      }
    },
    safeData(){
      const {safeGaugeData , safeLineChartData , safeScatterData } = this.resultData
        
      this.safe_gkGauge.data = safeGaugeData.conInd
      this.safe_gkGauge.pointerColor = safeGaugeData.conColor

      this.safe_wdGauge.data = safeGaugeData.stableInd
      this.safe_wdGauge.pointerColor = safeGaugeData.stableColor

      this.safe_yjGauge.data = safeGaugeData.warnInd
      this.safe_yjGauge.pointerColor = safeGaugeData.warnColor

      this.safe_linechart.data = safeLineChartData.conLine
      this.safe_linechart.data1 = safeLineChartData.stableline
      this.safe_linechart.data2 = safeLineChartData.warnDateLine
      this.safe_linechart.xtime = safeLineChartData.time
      this.safe_linechart.xInterval = Math.round(this.safe_linechart.xtime.length/5)

      //默认散点图数据根据后端返回的当前视图结果进行判断
      //0主视图 2侧视图 1俯视图
      if(this.safeScaleFlag == 0){
        if(safeScatterData.currentViewType == "0" && this.safeControlScatter == 0 || this.safeControlScatter == 1 && this.safeCurPage == this.$route.query.index){
          this.safeScatter2D = {...this.safeScatter2D , ...safeScatterData.scatterData}
          this.safeScatter2D.XName = "X"
          this.safeScatter2D.YName = "Y"
          this.resultData.safeScatterData.direction == 1 ? this.safeBoundary2 = true : this.safeBoundary2 = false
          this.resultData.safeScatterData.direction == 2 ? this.safeBoundary1 = true : this.safeBoundary1 = false
          this.resultData.safeScatterData.direction == 3 ? this.safeBoundary3 = true : this.safeBoundary3 = false
          this.resultData.safeScatterData.direction == 4 ? this.safeBoundary4 = true : this.safeBoundary4 = false
        } else if (safeScatterData.currentViewType == "1"  && this.safeControlScatter == 0 || this.safeControlScatter == 2 && this.safeCurPage == this.$route.query.index){
          this.safeScatter2D = {...this.safeScatter2D , ...safeScatterData.scatterData2}
          this.safeScatter2D.XName = "X"
          this.safeScatter2D.YName = "Z"
          this.resultData.safeScatterData.direction == 9 ? this.safeBoundary2 = true : this.safeBoundary2 = false
          this.resultData.safeScatterData.direction == 10 ? this.safeBoundary1 = true : this.safeBoundary1 = false
          this.resultData.safeScatterData.direction == 11 ? this.safeBoundary3 = true : this.safeBoundary3 = false
          this.resultData.safeScatterData.direction == 12 ? this.safeBoundary4 = true : this.safeBoundary4 = false
        } else if(safeScatterData.currentViewType == "2" && this.safeControlScatter == 0 || this.safeControlScatter == 3 && this.safeCurPage == this.$route.query.index){
          this.safeScatter2D = {...this.safeScatter2D , ...safeScatterData.scatterData1}
          this.safeScatter2D.XName = "Z"
          this.safeScatter2D.YName = "Y"
          this.resultData.safeScatterData.direction == 5 ? this.safeBoundary2 = true : this.safeBoundary2 = false
          this.resultData.safeScatterData.direction == 6 ? this.safeBoundary1 = true : this.safeBoundary1 = false
          this.resultData.safeScatterData.direction == 7 ? this.safeBoundary3 = true : this.safeBoundary3 = false
          this.resultData.safeScatterData.direction == 8 ? this.safeBoundary4 = true : this.safeBoundary4 = false
        }else if (this.safeCurPage != this.$route.query.index){
          this.safeControlScatter = 0
        }
      }

      this.safeMiniScatter1 = {...this.safeMiniScatter1 , ...safeScatterData.scatterData}
      this.safeMiniScatter1.data  = safeScatterData.scatterData.data.slice(-1)

      this.safeMiniScatter2 = {...this.safeMiniScatter2 , ...safeScatterData.scatterData1}
      this.safeMiniScatter2.data  = safeScatterData.scatterData1.data.slice(-1)

      this.safeMiniScatter3 = {...this.safeMiniScatter3 , ...safeScatterData.scatterData2}
      this.safeMiniScatter3.data  = safeScatterData.scatterData2.data.slice(-1)
    },
    fullData(){
      const {fullGaugeData , fullLineChartData , fullScatterData } = this.resultData
        
      this.full_gkGauge.data = fullGaugeData.conInd
      this.full_gkGauge.pointerColor = fullGaugeData.conColor

      this.full_wdGauge.data = fullGaugeData.stableInd
      this.full_wdGauge.pointerColor = fullGaugeData.stableColor

      this.full_yjGauge.data = fullGaugeData.warnInd
      this.full_yjGauge.pointerColor = fullGaugeData.warnColor

      this.full_linechart.data = fullLineChartData.conLine
      this.full_linechart.data1 = fullLineChartData.stableline
      this.full_linechart.data2 = fullLineChartData.warnDateLine
      this.full_linechart.xtime = fullLineChartData.time
      this.full_linechart.xInterval = Math.round(this.full_linechart.xtime.length/3)

      //默认散点图数据根据后端返回的当前视图结果进行判断
      //0主视图 2侧视图 1俯视图
      if( this.fullScaleFlag == 0 ){
        if(fullScatterData.currentViewType == "0" && this.fullControlScatter == 0 || this.fullControlScatter == 1 && this.fullCurPage == this.$route.query.index){
          this.fullImgUrl = `${this.$route.query.homePage}_FULL_Z`
          this.fullScatter2D = {...this.fullScatter2D , ...fullScatterData.scatterData}
          this.fullScatter2D.XName = "X"
          this.fullScatter2D.YName = "Y"
          this.resultData.fullScatterData.direction == 1 ? this.fullBoundary3 = true : this.fullBoundary3 = false
          this.resultData.fullScatterData.direction == 2 ? this.fullBoundary1 = true : this.fullBoundary1 = false
          this.resultData.fullScatterData.direction == 3 ? this.fullBoundary2 = true : this.fullBoundary2 = false
          this.resultData.fullScatterData.direction == 4 ? this.fullBoundary4 = true : this.fullBoundary4 = false
        } else if (fullScatterData.currentViewType == "1" && this.fullControlScatter == 0 || this.fullControlScatter == 2 && this.fullCurPage == this.$route.query.index){
          this.fullImgUrl = `${this.$route.query.homePage}_FULL_F`
          this.fullScatter2D = {...this.fullScatter2D , ...fullScatterData.scatterData2}
          this.fullScatter2D.XName = "X"
          this.fullScatter2D.YName = "Z"
          this.resultData.fullScatterData.direction == 9 ? this.fullBoundary3 = true : this.fullBoundary3 = false
          this.resultData.fullScatterData.direction == 10 ? this.fullBoundary1 = true : this.fullBoundary1 = false
          this.resultData.fullScatterData.direction == 11 ? this.fullBoundary2 = true : this.fullBoundary2 = false
          this.resultData.fullScatterData.direction == 12 ? this.fullBoundary4 = true : this.fullBoundary4 = false
        } else if(fullScatterData.currentViewType == "2" && this.fullControlScatter == 0 || this.fullControlScatter == 3 && this.fullCurPage == this.$route.query.index){
          this.fullImgUrl = `${this.$route.query.homePage}_FULL_C`
          this.fullScatter2D = {...this.fullScatter2D , ...fullScatterData.scatterData1}
          this.fullScatter2D.XName = "Z"
          this.fullScatter2D.YName = "Y"
          this.resultData.fullScatterData.direction == 5 ? this.fullBoundary3 = true : this.fullBoundary3 = false
          this.resultData.fullScatterData.direction == 6 ? this.fullBoundary1 = true : this.fullBoundary1 = false
          this.resultData.fullScatterData.direction == 7 ? this.fullBoundary2 = true : this.fullBoundary2 = false
          this.resultData.fullScatterData.direction == 8 ? this.fullBoundary4 = true : this.fullBoundary4 = false
        }else if (this.fullCurPage != this.$route.query.index){
          this.fullControlScatter = 0
        }
      }

      this.fullMiniScatter1 = {...this.fullMiniScatter1 , ...fullScatterData.scatterData}
      this.fullMiniScatter1.data  = fullScatterData.scatterData.data.slice(-1)

      this.fullMiniScatter2 = {...this.fullMiniScatter2 , ...fullScatterData.scatterData1}
      this.fullMiniScatter2.data  = fullScatterData.scatterData1.data.slice(-1)

      this.fullMiniScatter3 = {...this.fullMiniScatter3 , ...fullScatterData.scatterData2}
      this.fullMiniScatter3.data  = fullScatterData.scatterData2.data.slice(-1)

    },
    groupData(){
      const {groupEvaluation} = this.resultData
      this.bar = {...this.bar , ...groupEvaluation.columChart}
      var val = []
      this.bar.values.forEach((item)=>{
        val.push(item.toString().split(".")[0]) 
      })
      this.bar.values = val

      this.groups_linechart.data = groupEvaluation.scoreLine.value
      this.groups_linechart.xtime = groupEvaluation.scoreLine.time
      this.groups_linechart.xInterval = Math.round(this.groups_linechart.xtime.length/1)
    },
    async getData(){
      // 请求Body参数 ，实时界面开始结束时间传null，历史传时间戳
      // {
      //     "endTime": null,
      //     "startTime": null,
      //     "workShopName": "string"
      // }
      this.getPublicData()
      const params = {
        workShopName: this.$route.query.homePage,
        startTime: this.hisParams.startTime,
        endTime: this.hisParams.endTime
      }
      const {code , resultData} =  await homePage(params)
      if(code == "200"){
        this.resultData = resultData
        this.setRunStateInfo(resultData.runStateInfo)//装置部分使用，避免查询历史时调取两次查询首页api数据混乱
        if(this.safeControlScatter == 0){
          this.safeCurrViewName(resultData.safeScatterData.currentViewType)
        }
        if(this.fullControlScatter == 0){
          this.fullCurrViewName(resultData.fullScatterData.currentViewType)
        }
        this.safeData()
        this.fullData()
        this.groupData()
        this.timeX()
        this.setScatterColor()
      }
      //关闭查询历史时加载中提示
      if(this.message != null){
        this.message.close()
        this.message = null
      }
    },
    //状态颜色；散点颜色；工况、稳定、优化、预警时间趋势高低限
    async getPublicData(){
      const {code , resultData} =await getPublicConfig()
        if(code == "200"){
          this.baseStatusColor = resultData.statusColor.split(";")
          this.full_linechart.min = resultData.yjsjLineChartLowerLimit
          this.full_linechart.max = resultData.yjsjLineChartHighLimit
          this.full_linechart.y0Min = resultData.gkLineChartLowerLimit
          this.full_linechart.y0Max = resultData.gkLineChartHighLimit
          this.full_linechart.y0Interval =Math.round( (this.full_linechart.y0Max - this.full_linechart.y0Min) / 4 )
          this.full_linechart.interval =Math.round( (this.full_linechart.max - this.full_linechart.min) / 4 )

          this.safe_linechart.min = resultData.yjsjLineChartLowerLimit
          this.safe_linechart.max = resultData.yjsjLineChartHighLimit
          this.safe_linechart.y0Min = resultData.gkLineChartLowerLimit
          this.safe_linechart.y0Max = resultData.gkLineChartHighLimit
          this.safe_linechart.y0Interval =Math.round( (this.safe_linechart.y0Max - this.safe_linechart.y0Min) / 4 )
          this.safe_linechart.interval =Math.round( (this.safe_linechart.max - this.safe_linechart.min) / 4 )

          // this.groups_linechart.y0Min = resultData.comprehEvalScoreLowerLimit
          // this.groups_linechart.y0Max = resultData.comprehEvalScoreHighLimit
          // this.groups_linechart.y0Interval =Math.round( (this.groups_linechart.y0Max - this.groups_linechart.y0Min) / 4 )
      }
    },
    setScatterColor(){
      this.resultData.runStateInfo.modelList.forEach(item=>{
        if(item.modelEnName == "FULL" && item.stableWarnStatus == 1){
          this.fullScatterHisColor = ["#0D0DF5","#3B6FF2","#4671CB","yellow"]
        }else if (item.modelEnName == "FULL" && item.stableWarnStatus == 2){
          this.fullScatterHisColor = ["#0D0DF5","#3B6FF2","#4671CB","red"]
        }else if (item.modelEnName == "FULL" && item.stableWarnStatus == 0 || item.stableWarnStatus == 3){
          this.fullScatterHisColor = ["#0D0DF5","#3B6FF2","#4671CB","#B2ADAD"]
        }

        if(item.modelEnName == "SAFE" && item.stableWarnStatus == 1){
          this.safeScatterHisColor = ["#0D0DF5","#3B6FF2","#4671CB","yellow"]
        }else if (item.modelEnName == "SAFE" && item.stableWarnStatus == 2){
          this.safeScatterHisColor = ["#0D0DF5","#3B6FF2","#4671CB","red"]
        }else if (item.modelEnName == "SAFE" && item.stableWarnStatus == 0 || item.stableWarnStatus == 3){
          this.safeScatterHisColor = ["#0D0DF5","#3B6FF2","#4671CB","#B2ADAD"]
        }
      })
    },
     // 定时器方法
    startTimer() {
      // 启动定时器，每秒执行一次计数
      this.timerId = setInterval(() => {
        if(this.isHis == 1){
          this.getData()
        }
        else if(this.isHis == 0){
          this.message = this.$message({
            dangerouslyUseHTMLString: true,
            center: true,
            duration:0,
            message: '<strong><i class="el-icon-loading"></i> 加载中。。。</strong>'
          });
          this.setIsHis(2)
          this.getData()
        }
      }, 3000);
    },
    stopTimer() {
      // 停止定时器
      clearInterval(this.timerId);
    },
    jumpModelPage(curPage){
      console.log(`${this.$route.query.homePage}_${curPage}`,this.resultData.runStateInfo.modelList)
      const curr = `${this.$route.query.homePage}_${curPage}`
      this.resultData.runStateInfo.modelList.forEach((item,index) => {
        if(curr == item.modelFullName && item.hasRole == true){
          jumpModelBtn(item.modelUrl,curr,index+1,this.$route.query.homePage)
        }else if(curr == item.modelFullName && item.hasRole == false){
          Message.error("您没有权限进入该模型")
        }
      })
      this.isHis == 2 ? this.setIsHis(0) : this.setIsHis(1)
    },
  },
  created() {
    this.getData()
    this.timeX()
  },
  mounted(){
    this.startTimer()
  },
  destroyed(){
    this.stopTimer()
  }
};
</script>

<style lang="less" scoped>
.containter {
  color: white;
  height: 920px;
  width: 1920px;
  .cursor:hover {
    cursor: pointer;
  }
  .center {
    text-align: center;
  }
  .smallTile {
    font-size: 25px;
  }
  //安全
  .safe {
    height: 860px;
    .safeScatter {
      width: 290px;
      height: 300px;
      position: relative;
      top: -5px;
      .scater {
        height: 355px;
      }
      img {
        position: absolute;
        top: 37px;
        left: 5px;
        width: 270px;
        height: 268px;
      }
      .securityBoundary1,
      .securityBoundary2,
      .securityBoundary3,
      .securityBoundary4,
      .desc1,
      .desc2 {
        position: absolute;
        font-size: 12px;
      }
      .securityBoundary1 {
        left: -10px;
        top: 65px;
      }
      .securityBoundary2 {
        right: -10px;
        top: 65px;
      }
      .securityBoundary3 {
        left: -10px;
        bottom: 15px;
      }
      .securityBoundary4 {
        right: -10px;
        bottom: 15px;
      }
      .desc1,
      .desc2 {
        color: rgb(148, 146, 146);
        font-size: 12px;
      }
      .desc1 {
        top: 20px;
        left: -20px;
      }
      .desc2 {
        top: 35px;
        left: -20px;
      }
    }
    .safeLine {
      height: 180px;
    }
    .safe_gauge {
      height: 130px;
    }
    .bigWormbox {
      border-radius: 50%;
      border: 5px solid green;
    }
    .wormboxMini {
      position: relative;
      top: 50px;
      .wormbox {
        width: 55px;
        height: 50px;
        position: absolute;
        top: 5px;
      }
      .currentView {
        padding-top: 20px;
      }
      .miniScatter {
        position: relative;
        height: 40px;
        top: 0;
        .miniScatter1 {
          position: absolute;
          width: 60px;
          height: 125px;
          top: -30px;
          left: -3px;
        }
        .leftTop1 , .rightTop1 , .leftBottom1 , .rightBottom1 ,
        .leftTop2 , .rightTop2 , .leftBottom2 , .rightBottom2 ,
        .leftTop3 , .rightTop3 , .leftBottom3 , .rightBottom3
        {
          position: absolute;
          width: 10px;
          height: 10px;
          background: red;
          border-radius: 50%;
        }
        .leftTop1 , .leftTop2 , .leftTop3{
          left: 0px;
          top: 5px;
        }
        .rightTop1 , .rightTop2 , .rightTop3{
          left: 48px;
          top: 5px;
        }
        .rightBottom1 , .rightBottom2 , .rightBottom3{
          left: 48px;
          top: 45px;
        }
        .leftBottom1 , .leftBottom2 , .leftBottom3{
          left: 0px;
          top: 45px;
        }
      }
      .miniView {
        position: relative;
        z-index: 999;
        .el-button {
          margin-left: 95px;
        }
        .safeFrontView,
        .safeSideView,
        .safeVerticalView {
          position: absolute;
        }
        .safeFrontView {
          top: 10px;
          left: -90px;
        }
        .safeSideView {
          top: 10px;
          left: -10px;
        }
        .safeVerticalView {
          top: 10px;
          left: 65px;
        }
      }
    }
    .isScaleBtn {
      top: 110px;
      left: 275px;
      margin-top: 10px;
    }
    .list {
      /deep/ .el-table__body-wrapper::-webkit-scrollbar {
        width: 0;
      }
      /deep/ .el-table th {
        background-color: transparent !important;
      }
      /deep/ .el-table tr,
      .el-table td {
        background-color: transparent !important;
        font-size: 14px;
      }
      /deep/ .el-table tbody tr:hover > td {
        background-color: rgb(24, 43, 129);
      }
      /deep/ .el-table .el-table__cell {
        padding: 2px 0;
        border: 0;
      }
      .el-table::before {
        height: 0;
      }
    }
  }
  .device {
    height: 450px;
  }
  //运行评估
  .group {
    height: 350px;
    position: relative;
    .teamScore {
      height: 150px;
      width: 200px;
      position: absolute;
      left: -40px;
    }
    .info {
      position: absolute;
      left: 155px;
      font-size: 14px;
    }
    .el-button {
      padding: 5px;
    }
    .linechart {
      height: 150px;
      width: 200px;
      left: -20px;
      position: absolute;
      top: 160px;
    }
  }
  //全流程
  .full {
    height: 350px;
    .fullTitle {
      text-align: left;
    }
    .fullLine,
    .fullScatter {
      height: 180px;
    }
    .full_Gauge {
      height: 160px;
    }
    .fullScatter {
      position: relative;
      left: -40px;
      top: -60px;
      .scater {
        height: 308px;
        width: 255px;
        padding-left: 88px;
      }
      img {
        position: absolute;
        top: 37px;
        left: 90px;
        width: 240px;
        height: 225px;
      }
      .currStatus {
        font-size: 14px;
        position: absolute;
        right: -40px;
        bottom: 20px;
      }
      .status {
        font-size: 14px;
        position: absolute;
        right: -23px;
        bottom: 40px;
      }
      .gradient,
      .mark1,
      .mark2,
      .securityBoundary1,
      .securityBoundary2,
      .securityBoundary3,
      .securityBoundary4,
      .desc1,
      .desc2 {
        position: absolute;
        font-size: 12px;
      }
      .gradient{
        height: 10px;
        width: 150px;
        background: linear-gradient(90deg, #2e2d2d 0%, #203864 40%, #00b050 100%);
        right: 10px;
        top: 15px;
      }
      .mark1{
        top: 25px;
        left: 255px;
      }
      .mark2{
        top: 25px;
        right: 10px;
      }
      .securityBoundary1 {
        left: 70px;
        top: 65px;
      }
      .securityBoundary2 {
        left: 70px;
        top: 225px;
      }
      .securityBoundary3 {
        left: 315px;
        top: 65px;
      }
      .securityBoundary4 {
        left: 315px;
        top: 225px;
      }
      .bigWormbox {
        border-radius: 50%;
        border: 5px solid green;
      }
      .desc1,
      .desc2 {
        color: rgb(148, 146, 146);
        font-size: 12px;
      }
      .desc1 {
        top: 10px;
        left: 60px;
      }
      .desc2 {
        top: 25px;
        left: 60px;
      }
    }
    .isScaleBtn {
      position: absolute;
      top: 110px;
      right: 10px;
    }
    .wormboxMini {
      position: relative;
      top: 35px;
      left: 10px;
      .wormbox {
        width: 55px;
        height: 50px;
        position: absolute;
        top: 5px;
      }
      .currentView {
        padding-top: 20px;
      }
      .miniScatter {
        position: relative;
        height: 40px;
        top: 0;
        .miniScatter1 {
          position: absolute;
          width: 60px;
          height: 125px;
          top: -30px;
          left: -3px;
        }
      }
      .miniView {
        padding-left: 48px;
        position: absolute;
        top: 73px;
        z-index: 999;
        .el-button {
          margin-left: 60px;
        }
      }
      .leftTop1 , .rightTop1 , .leftBottom1 , .rightBottom1 ,
      .leftTop2 , .rightTop2 , .leftBottom2 , .rightBottom2 ,
      .leftTop3 , .rightTop3 , .leftBottom3 , .rightBottom3
      {
        position: absolute;
        width: 10px;
        height: 10px;
        background: red;
        border-radius: 50%;
      }
      .leftTop1 , .leftTop2 , .leftTop3{
        left: 0px;
        top: 5px;
      }
      .rightTop1 , .rightTop2 , .rightTop3{
        left: 48px;
        top: 5px;
      }
      .rightBottom1 , .rightBottom2 , .rightBottom3{
        left: 48px;
        top: 45px;
      }
      .leftBottom1 , .leftBottom2 , .leftBottom3{
        left: 0px;
        top: 45px;
      }
    }
  }
}
</style>
